import { AmountUtils, cn, FormatUtils } from '@shared/utils';
import { type AccountResponse } from '@shared/api';
import { AccountStatus } from './accountStatus';
import { AccountManipulations } from './accountManipulations';
import { AccountVcfcDetails } from './accountVcfcDetails';
import { AccountsList } from './accountsList';
import { Text } from '@shared/widgets';

interface AccountPaymentTileVcfcProps {
  className?: string;
  account: AccountResponse;
  mainAccount?: AccountResponse;
  subAccounts?: AccountResponse[];
  withAccounts?: boolean;
  selectedAccountId?: number;
  onSelectAccount?: (accountId: number) => void;
}

export const AccountPaymentTileVcfc = (props: AccountPaymentTileVcfcProps) => {
  return (
    <div className={cn('flex flex-col', props.className)}>
      <div className='flex flex-col rounded-tl-lg rounded-tr-lg bg-white p-5 dark:bg-soft-black'>
        <div className='flex items-center justify-between'>
          <Text size='3xl'>{AmountUtils.transformToAmountWithCurrency(props.account.availableBalance ?? 0, props.account.currency)}</Text>
          <AccountStatus account={props.account} />
        </div>
        {!props.withAccounts && (
          <AccountManipulations
            account={props.account}
            mainAccount={props.mainAccount}
            subAccounts={props.subAccounts}
            selectedAccountId={props.selectedAccountId}
            onSelectAccount={props.onSelectAccount}
          />
        )}
        <div className='mt-2 flex flex-col gap-2'>
          <Text weight='medium'>{props.account.name || FormatUtils.formatAccountNumber(props.account.accountNumber)}</Text>
          <Text weight='semibold' size='xxs' color='secondary-light'>
            {props.account.productName}
          </Text>
        </div>
        <hr className='my-4 text-slate/15' />
        <AccountVcfcDetails account={props.account} />
      </div>
      {props.withAccounts && !!props.subAccounts?.length && <AccountsList accounts={props.subAccounts} />}
    </div>
  );
};
